import React from 'react';

interface ChevronLeftIconProps {
  size?: number;
}

const ChevronLeftIcon: React.FC<ChevronLeftIconProps> = ({ size = 12 }) => (
  <svg width={size} viewBox="-1 0 9 18" fill="none">
    <path d="M 6 0 L 0 9 L 6 18" stroke="black" />
  </svg>
);

export default ChevronLeftIcon;
